// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const kingler: PokeData = {
  "id": 99,
  "name": "kingler",
  "height": 13,
  "weight": 600,
  "base_experience": 166,
  "types": [
    PokeType.WATER
  ],
  "api_moves": [
    "vice-grip",
    "guillotine",
    "swords-dance",
    "slam",
    "stomp",
    "leer",
    "water-gun",
    "bubble-beam",
    "agility",
    "harden",
    "amnesia",
    "bubble",
    "crabhammer",
    "flail",
    "protect",
    "metal-claw",
    "mud-sport",
    "mud-shot",
    "hammer-arm",
    "brine",
    "wide-guard",
    "razor-shell"
  ],
  "moves": [
    "leer",
    "bubble-beam",
    "agility",
    "bubble",
    "protect",
    "metal-claw",
    "mud-shot",
    "brine",
    "hydro-pump",
    "aqua-tail",
    "whirlpool",
    "life-dew",
    "water-spout"
  ],
  "evolution_chain": {
    "id": 43,
    "item": null,
    "species": [
      {
        "name": "krabby",
        "order": 107,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "kingler",
        "order": 108,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": 98,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 28,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 100,
    "speed": 110,
    "ability_power": 190
  },
  "stat_changes": [],
  "catch_rate": 60,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
